// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AllDownloadsText__container-ff8bce {
  color: var(--base-110);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/AllDownloads/AllDownloadsText/AllDownloadsText.styles.m.css"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AACF","sourcesContent":[".container {\n  color: var(--base-110);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AllDownloadsText__container-ff8bce`
};
module.exports = ___CSS_LOADER_EXPORT___;
